import Label from "./common/Label";
import Description from "./common/Description";

export default function SwitchRoot({
    children,
    label,
    description,
    help,
    containerClass = "flex items-start justify-between gap-2",
    labelMargin,
}) {
    return (
        <label className={containerClass}>
            <div className="flex-1">
                <Label label={label} help={help} labelMargin={labelMargin} />
                <Description
                    description={description}
                    containerClass="text-xs text-gray-500 mt-1"
                />
            </div>
            {children}
        </label>
    );
}
